import { render, staticRenderFns } from "./BlurbComponent.vue?vue&type=template&id=155645a2&scoped=true&"
import script from "./BlurbComponent.vue?vue&type=script&lang=js&"
export * from "./BlurbComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlurbComponent.vue?vue&type=style&index=0&id=155645a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155645a2",
  null
  
)

export default component.exports